module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "width": "400"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "elevation-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Change Password")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-alert', {
    attrs: {
      "show": _vm.errorMessage !== null,
      "dismissible": "",
      "variant": "danger"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMessage))])])], 1), _vm._v(" "), _c('form', [_c('v-container', {
    staticClass: "remove-padding",
    attrs: {
      "container--fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": _vm.show.oldPassword ? 'visibility_off' : 'visibility',
      "type": _vm.show.oldPassword ? 'text' : 'password',
      "error-messages": _vm.currentPasswordErrors,
      "autocomplete": "current-password",
      "name": "current-password",
      "label": "Current Password"
    },
    on: {
      "input": function($event) {
        return _vm.$v.user.oldPassword.$touch()
      },
      "blur": function($event) {
        return _vm.$v.user.oldPassword.$touch()
      },
      "click:append": function($event) {
        _vm.show.oldPassword = !_vm.show.oldPassword
      }
    },
    model: {
      value: (_vm.user.oldPassword),
      callback: function($$v) {
        _vm.$set(_vm.user, "oldPassword", $$v)
      },
      expression: "user.oldPassword"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-group--focused",
    attrs: {
      "error-messages": _vm.passwordError,
      "append-icon": _vm.show.password ? 'visibility_off' : 'visibility',
      "type": _vm.show.password ? 'text' : 'password',
      "autocomplete": "new-password",
      "name": "new-password",
      "color": "#1687c0",
      "label": "New Password"
    },
    on: {
      "input": function($event) {
        return _vm.$v.user.newPassword.$touch()
      },
      "blur": function($event) {
        return _vm.$v.user.newPassword.$touch()
      },
      "click:append": function($event) {
        _vm.show.password = !_vm.show.password
      }
    },
    model: {
      value: (_vm.user.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.user, "newPassword", $$v)
      },
      expression: "user.newPassword"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-group--focused",
    attrs: {
      "append-icon": _vm.show.repeatPassword ? 'visibility_off' : 'visibility',
      "type": _vm.show.repeatPassword ? 'text' : 'password',
      "error-messages": _vm.repeatPasswordErrors,
      "name": "repeat-password",
      "autocomplete": "new-password",
      "label": "Repeat Password"
    },
    on: {
      "input": function($event) {
        return _vm.$v.user.repeatPassword.$touch()
      },
      "blur": function($event) {
        return _vm.$v.user.repeatPassword.$touch()
      },
      "click:append": function($event) {
        _vm.show.repeatPassword = !_vm.show.repeatPassword
      }
    },
    model: {
      value: (_vm.user.repeatPassword),
      callback: function($$v) {
        _vm.$set(_vm.user, "repeatPassword", $$v)
      },
      expression: "user.repeatPassword"
    }
  })], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary",
      "disabled": _vm.$v.user.$invalid
    },
    on: {
      "click": _vm.changePassword
    }
  }, [_vm._v("Change Password")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e5cb861"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/User/ChangePasswordModal.vue
// module id = 2090
// module chunks = 0